import { FC, ReactNode } from "react";
import { Wrapper, InnerWrapper } from "./CenterWrapper.styled";

interface Props {
  children?: ReactNode;
}

const CenterWrapper: FC<Props> = ({ children }) => {
  return (
    <Wrapper>
      <InnerWrapper>{children}</InnerWrapper>
    </Wrapper>
  );
};

export default CenterWrapper;
